import React, { useEffect, useState } from 'react'
import { Box, Flex } from 'front-end/src/components'
import { Trans } from '@lingui/macro'
import Select from '../../../../../../components/common/select/Select'
import { EventFilterTypeEnum } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { css } from '@emotion/react'
import { useEditCampaignFilterContext } from 'front-end/src/pages/manage-campaign-page/components/campaign-audience/modals/enrolment-modal/EditCampaignFilterContext'
import {
  getEventStatusOptionsMap,
  transformToSelectOptions
} from 'front-end/src/pages/manage-campaign-page/components/campaign-audience/CampaignAudienceHelpers'
import { EventSelector } from 'front-end/src/pages/manage-campaign-page/components/campaign-audience/modals/event-modal/event-selector/EventSelector'

export const EditCampaignEventModal = () => {
  const { editedFilter, setEditedFilter } = useEditCampaignFilterContext()
  const [selectedEvents, setSelectedEvents] = useState({
    events: editedFilter.eventFilterSetup?.eventIds ?? [],
    recEvents: editedFilter.eventFilterSetup?.recurringEventIds ?? []
  })

  const eventStatusOptions = transformToSelectOptions(
    getEventStatusOptionsMap()
  )

  const [userStatus, setUserStatus] = useState<EventFilterTypeEnum>(
    editedFilter.eventFilterSetup?.eventFilterType ||
      EventFilterTypeEnum.any_status
  )

  useEffect(() => {
    setEditedFilter({
      ...editedFilter,
      eventFilterSetup: {
        eventFilterType: userStatus,
        recurringEventIds: selectedEvents.recEvents,
        eventIds: selectedEvents.events
      }
    })
  }, [userStatus, selectedEvents])

  return (
    <>
      <Flex mt="16px" mb="8px">
        <Flex mr="16px" align="center" textAlign="right" lineHeight="20px">
          <Trans>User status is</Trans>
        </Flex>

        <Box>
          <Select
            options={eventStatusOptions}
            value={eventStatusOptions.find(({ value }) => {
              return value === userStatus
            })}
            css={css`
              .Select__control {
                min-width: 400px;
              }
            `}
            aria-label={`event invitation`}
            onChange={(option) => {
              setUserStatus(option?.value)
            }}
          />
        </Box>
      </Flex>

      <Box mb="8px" mt="32px">
        <Trans>in any of these events</Trans>
      </Box>

      <EventSelector
        selectedEvents={selectedEvents}
        setSelectedEvents={setSelectedEvents}
      />
    </>
  )
}
